// extracted by mini-css-extract-plugin
export var inlineLink = "_a8-0";
export var inlineLinkButton = "_a8-1";